// JOBE-0106: ActivityTab — UI mock per Phase 5 Out-of-scope.
// Static placeholder rows; NO fetch. Project-scoped activity feed is
// out of scope until a feed-surface justification exists.

import React from 'react';

const ACTIVITY_ROWS = [
  { id: 'a1', who: 'iris', verb: 'edited briefing "kickoff"', when: '3h ago' },
  { id: 'a2', who: 'shawn', verb: 'added watcher fern', when: '6h ago' },
  { id: 'a3', who: 'router', verb: 'closed task #21', when: 'yesterday' },
  { id: 'a4', who: 'iris', verb: 'rolled up Q1 results', when: '2d ago' },
  { id: 'a5', who: 'shawn', verb: 'archived task #4', when: '3d ago' },
];

export function ActivityTab() {
  return (
    <section
      className="project-activity-tab"
      data-testid="project-activity-tab"
      aria-label="Project activity"
    >
      <header className="lane-header">
        <h3 className="lane-title">Activity</h3>
        <span className="lane-preview-marker mono">preview</span>
      </header>
      <ul className="activity-rows">
        {ACTIVITY_ROWS.map((r) => (
          <li key={r.id} className="activity-row">
            <span className="mono activity-who">{r.who}</span>
            <span className="activity-verb"> {r.verb}</span>
            <span className="muted activity-when mono"> · {r.when}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
